import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core'
import { LayerSimulationWarningService } from 'src/app/shared/layers/layer-simulation-warning.service'
import { DialogCloseEventWithResult, ModalService } from '@inst-iot/bosch-angular-ui-components'
import { ToastService } from 'src/app/shared/services/toast.service'

@Component({
  selector: 'app-simulation-view-actions-remove-simulations',
  templateUrl: './simulation-view-actions-remove-simulations.component.html',
  standalone: false,
})
export class SimulationViewActionsRemoveAllSimulations {
  public isLoading: boolean = false
  public visibleSimulationsCount: number = 0

  constructor(
    private simulationWarningLayerService: LayerSimulationWarningService,
    private modalService: ModalService,
    private toastService: ToastService,
  ) {}

  public async openDeleteAllVisibleSimulationsDialog(
    tpl: TemplateRef<any>,
    position: 'top' | 'middle' | 'bottom',
  ) {
    this.visibleSimulationsCount =
      this.simulationWarningLayerService.getAllVisibleSimulation().length

    const closeEventResult = await this.modalService.open<DialogCloseEventWithResult>(tpl, {
      maxWidth: '650px',
      position,
    })

    switch (closeEventResult.event) {
      case 'confirmed':
        this.deleteAllVisibleSimulations()
        break
      default:
        break
    }
  }

  private async deleteAllVisibleSimulations() {
    if (this.isLoading) {
      return // Prevent execution if already loading
    }

    this.isLoading = true
    await this.simulationWarningLayerService.removeAllVisibleWarnings({
      handleNextDeleteSuccess: () => {},
      handleNextDeleteError: (error: any) => {
        this.toastService.show({
          type: 'error',
          message: `Error deleting visible simulations: ${error.message || error}`,
        })
        this.isLoading = false
      },
      handleAfterAllDeletion: () => {
        this.toastService.show({
          type: 'success',
          message: `All visible simulations have been deleted successfully.`,
        })
        this.isLoading = false
        this.simulationWarningLayerService.startReloadingAfterMutation()
      },
    })
  }
}
